import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Nav } from 'react-bootstrap';

import { useAuth, useApp } from '../../context';

function SidebarNavItem({ item }) {
  const { user } = useAuth();
  const { updateApp } = useApp();
  const { t } = useTranslation();
  const location = useLocation();

  const handleClick = (e) => {
    if (item.onClick) {
      e.preventDefault();
      item.onClick(t, user);
    }
    updateApp({ menuVisible: false });
  };

  return (
    <Nav.Item className={item.classes || undefined}>
      <Nav.Link
        as={item.to ? NavLink : undefined}
        to={item.to ? { pathname: item.to, state: { from: location.pathname } } : undefined}
        onClick={handleClick}
        href={item.href ? item.href : undefined}
        target={item.newWindow ? '_blank' : undefined}
      >
        {item.iconClass && (
          <span className="d-inline-block item-icon-wrapper">
            <i className={item.iconClass} />
          </span>
        )}
        {item.title && <span className="sidebar-hover">{t(item.title)}</span>}
      </Nav.Link>
    </Nav.Item>
  );
}
//  htmlBefore: '<i class="sila-icon individual"></i>',
SidebarNavItem.propTypes = {
  /**
   * The item object.
   */
  item: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    iconClass: PropTypes.string,
    to: PropTypes.string,
    Permissions: PropTypes.func,
    onClick: PropTypes.func,
    newWindow: PropTypes.bool,
    href: PropTypes.string,
  }).isRequired,
};

export default SidebarNavItem;
